// https://javascriptforwp.com/adding-react-to-a-wordpress-theme-tutorial/

const { render, useState, useEffect } = wp.element;
import Axios from 'axios';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard, Scrollbar } from 'swiper';

export const SlideTitle = ({ data }) => {
    // console.log(data);
    return (
        <>
            <h6 className='slidetagline'>
                {data.acf.tagline}
            </h6>
            <h6 className='slidetagline onsmall'>
                {data.title.rendered}
            </h6>
        </>
    );
};

const CustomSwiper = ({ spaceBetween, slidesPerView, postType, spvBreak, sbBreak }) => {
    // console.log(spaceBetween, slidesPerView);

    const [count, setCount] = useState(0);
    const [post, setPost] = useState(null);
    const [hover, setHover] = useState(null);
    const [slideHover, setSlideHover] = useState([]);
    const [slideImgs, setSlideImgs] = useState([]);
    const [theActiveSlide, setTheActiveSlide] = useState(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);


    const [activeSlideString, setActiveSlideString] = useState(".swiper-slide.swiper-slide-next");
    let activeSlide = document.querySelector(activeSlideString);
    // let activeSlide = document.querySelector(".swiper-slide.swiper-slide-next");

    function checkForImage(data, type) {
        let chosen = null;
        slideImgs.map((img, idx) => {
            if (data === img.postid && type === img.type) {
                chosen = img.imgurl;
            };
            return chosen;
        });
        return chosen;
    };

    async function getImageByID(data, acf, idx) {
        // console.log(idx);
        if (data !== null) {
            Axios.get(`/wp-json/wp/v2/media/${parseInt(data)}`)
                .then((res) => {
                    let imgurl = res.data.media_details.sizes.full.source_url;
                    switch (acf) {
                        case "init_image":
                            setSlideImgs(images => [...images, { imgurl, postid: idx, type: "init_image", }]);
                            // slideImgs.push({ imgurl, postid: idx, type: "init_image", });
                            break;
                        case "hover_image":
                            setSlideImgs(images => [...images, { imgurl, postid: idx, type: "hover_image", }]);
                        // slideImgs.push({ imgurl, postid: idx, type: "hover_image", });
                        default:
                            break;
                    };
                })
                .catch((err) => console.error(err));
        };
    };

    const handleWindowResize = () => {
        setWindowWidth(window.innerWidth);
        if (windowWidth <= 768) {
            setActiveSlideString(".swiper-slide.swiper-slide-active");
        } else if (windowWidth >= 768) {
            setActiveSlideString(".swiper-slide.swiper-slide-next");
        };
    };

    useEffect(() => {
        Axios.get(`/wp-json/wp/v2/${postType ? postType : "posts"}`)
            .then((res) => {
                let postdata = res.data;

                postdata.map(async (d, idx) => ({
                    ...d,
                    hover_url: await getImageByID(d.acf.hover_image, "hover_image", idx),
                    init_url: await getImageByID(d.acf.init_image, "init_image", idx),
                }))

                setPost(postdata);
            })
            .catch((err) => console.error(err));

        window.addEventListener("resize", handleWindowResize);
        window.addEventListener("DOMContentLoaded", handleWindowResize);
        return () => {
            window.removeEventListener("resize", handleWindowResize);
            window.removeEventListener("DOMContentLoaded", handleWindowResize);
        };

    }, [setPost, setTheActiveSlide, setWindowWidth, windowWidth, setActiveSlideString,]);

    if (post) {
        return (
            <>
                <div className="swiper-gps-prev"
                    onClick={((e) => setTheActiveSlide(activeSlide))}
                >
                    <i class="fa-sharp fa-solid fa-chevron-left"></i>
                </div>
                <Swiper
                    grabCursor={true}
                    slidesPerView={parseInt(slidesPerView)}
                    spaceBetween={parseInt(spaceBetween)}
                    scrollbar={false}
                    navigation={{
                        nextEl: '.swiper-gps-next',
                        prevEl: '.swiper-gps-prev',
                    }}
                    loop
                    initialSlide={0}
                    pagination
                    keyboard={{
                        enabled: true,
                        onlyInViewport: true,
                    }}
                    modules={[Scrollbar, Navigation, Pagination, Keyboard]}
                    breakpoints={{
                        // when window width is >= 768px
                        768: {
                            slidesPerView: parseInt(spvBreak),
                            spaceBetween: parseInt(sbBreak),
                        },
                    }}
                    id="swiperContainer"
                    onKeyPress={((e) => setTheActiveSlide(activeSlide))}
                    onMouseOver={((e) => setTheActiveSlide(activeSlide))}
                    onMouseLeave={((e) => setTheActiveSlide(activeSlide))}
                    onMouseEnter={((e) => setTheActiveSlide(activeSlide))}

                >
                    {post &&
                        post.map((p, i) => {
                            let hv = checkForImage(i, "hover_image");
                            let ii = checkForImage(i, "init_image");
                            let bgimage = ii;
                            if (slideHover.slide == i && slideHover.state == true) {
                                bgimage = hv;
                            };
                            // if (activeSlide && activeSlide.classList.value == "swiper-slide swiper-slide-next") {
                            //     bgimage = hv;
                            // };
                            if (activeSlide) {
                                let id = activeSlide.getAttribute("data-swiper-slide-index");
                                if (id == i) {
                                    bgimage = hv;
                                }
                            };
                            let postTitle = p?.title.rendered;
                            let anchor = postTitle.replace(" ", "");
                            let postLink = p?.link;
                            let theLink = postLink.slice(0, -1);
                            // console.log(p?.id);
                            return (
                                <SwiperSlide
                                    key={i}
                                    id={i}
                                    data-slidename={p.slug}
                                    style={{
                                        backgroundImage: `url(${bgimage})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "50% 50%",
                                        transition: 'all ease-in-out 300ms',
                                    }}
                                    onMouseEnter={(e) => {
                                        // console.log(e?.target?.id);
                                        setSlideHover({ slide: e?.target?.id, state: true, });
                                    }}
                                    onMouseLeave={(e) => {
                                        // console.log(e?.target?.id);
                                        setSlideHover({ slide: e?.target?.id, state: false, });
                                    }}
                                    onClick={() => window.location = `${theLink}#${p?.id}`}
                                >
                                    {ii ? null : p.title.rendered}
                                </SwiperSlide>
                            )
                        })
                    }
                    {post &&
                        post.map((p, i) => {
                            if (activeSlide !== null) {
                                let actSlideName = activeSlide.getAttribute("data-slidename");
                                // setSlideChange(true);
                                if (p.slug == actSlideName) {
                                    return (
                                        <SlideTitle data={p} />
                                    );
                                }
                            };
                            return (
                                null
                            );
                        })
                    }
                </Swiper>
                <div className="swiper-gps-next"
                    onClick={((e) => setTheActiveSlide(activeSlide))}
                >
                    <i class="fa-sharp fa-solid fa-chevron-right"></i>
                </div>
            </>
        );
    };

    return (
        <>
            <h4 style={{ color: "white", }}>Loading...</h4>
        </>
    );
};

const reactEl = document.querySelector(".react-swiper-component"),
    slidesPerView = reactEl.dataset.slidesperview,
    spaceBetween = reactEl.dataset.spacebetween,
    postType = reactEl.dataset.posttype,
    spvBreak = reactEl.dataset.spv768break,
    sbBreak = reactEl.dataset.sb768break;


if (reactEl) render(
    <CustomSwiper
        spaceBetween={spaceBetween}
        slidesPerView={slidesPerView}
        postType={postType}
        spvBreak={spvBreak}
        sbBreak={sbBreak}
    />,
    document.getElementById(`${reactEl.id}`)
);